import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FingerIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10.8785 4C9.52207 4 8.36413 4.94368 8.03425 6.24561C7.89861 6.78098 7.35464 7.10502 6.81927 6.96937C6.28391 6.83372 5.95987 6.28976 6.09552 5.75439C6.63989 3.60586 8.56534 2 10.8785 2C13.1917 2 15.1171 3.60586 15.6615 5.75439C15.7971 6.28976 15.4731 6.83372 14.9377 6.96937C14.4024 7.10502 13.8584 6.78098 13.7228 6.24561C13.3929 4.94368 12.2349 4 10.8785 4ZM10.8785 6.5C10.4941 6.5 10.1558 6.82092 10.1558 7.25V13C10.1558 13.3477 9.9752 13.6704 9.67886 13.8523C9.38251 14.0342 9.01297 14.049 8.70296 13.8916L7.03072 13.0422C6.72902 12.889 6.35823 12.9728 6.14772 13.2579C5.98481 13.4785 5.95338 13.7764 6.06971 14.0296L8.54985 19.4283C8.71298 19.7834 9.05757 20 9.42527 20H17.0312C17.5515 20 18 19.5671 18 19V13.591C18 13.114 17.6771 12.717 17.2456 12.6158L11.6013 11.2927V7.25C11.6013 6.82092 11.263 6.5 10.8785 6.5ZM8.15581 7.25C8.15581 5.74608 9.36007 4.5 10.8785 4.5C12.397 4.5 13.6013 5.74608 13.6013 7.25V9.70731L17.7021 10.6686C19.0573 10.9863 20 12.2054 20 13.591V19C20 20.642 18.6856 22 17.0312 22H9.42527C8.2631 22 7.21628 21.3164 6.73245 20.2632L4.25231 14.8645C3.83298 13.9517 3.94164 12.8787 4.53874 12.0699C5.32347 11.0071 6.75451 10.6587 7.93642 11.2591L8.15581 11.3705V7.25Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FingerIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FingerIcon);
